import { styled } from 'styled-components'
import { LinkList, LinkListItem, LoadingSpinner } from 'suomifi-ui-components'
import { FormContainer as FormContainerBase } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'

export const StyledLinkList = styled(LinkList)``
export const StyledLoadingSpinner = styled(LoadingSpinner)``

export const FormContainer = styled(FormContainerBase)`
  & > section:last-child {
    border: 0;
  }

  section ul:last-child {
    margin-bottom: ${(props) => props.theme.spacing.xxl};
  }

  p + .fi-inline-alert {
    margin-top: ${({ theme }) => theme.spacing.m};
  }

  ${StyledLinkList}, ${StyledLoadingSpinner} {
    margin-top: ${(props) => props.theme.spacing.xl};
  }
`

export const StyledLinkListItem = styled(LinkListItem)`
  & .fi-icon {
    margin-left: ${(props) => props.theme.spacing.xs};
  }

  & .fi-icon:first-child {
    margin-left: 0;
    margin-right: ${(props) => props.theme.spacing.xs};
    width: 25px;
    height: 25px;
    vertical-align: top;
  }

  margin: ${(props) => props.theme.spacing.m} 0;
`
